import R from 'ramda';
import { reducerWrapper } from '../support/utils';
import {
  PRODUCT_FEED_CAMPAIGN_CREATED,
  PRODUCT_FEED_CAMPAIGNS_LOADED,
  PRODUCT_FEED_CAMPAIGN_ARCHIVED,
  PRODUCT_FEED_CAMPAIGN_UPDATED,
  PRODUCT_FEED_JOBS_LOADED,
  PRODUCT_FEED_FEED_CREATED,
  PRODUCT_FEED_FEEDS_LOADED,
  PRODUCT_FEED_FEED_SAVED,
  PRODUCT_FEED_FEED_ARCHIVED,
  PRODUCT_FEED_RESOURCES_LOADED,
  PRODUCT_FEED_RESOURCE_CREATED,
  PRODUCT_FEED_TRANSFORMED_LOADED,
  PRODUCT_FEED_TRANSFORMED_CREATED,
  PRODUCT_FEED_CONFIG_LOADED,
  PRODUCT_FEED_CONFIG_CREATED
} from '../actions/ProductFeedActions';

const INIT_STATE = {
  campaigns: [],
  feeds: false,
  resources: [],
  transformed: [],
  jobs: [],
  providers: []
};

function reassociateFeedsWithResources(state) {
  // this unfortunate bit of code is required due to changes made in the app service
  state.feeds = R.map(feed => {
    if (feed.resource_id) {
      return feed;
    }
    const resource =
      R.find(R.propEq('ads_product_feed_id', feed.id), state.resources || []) ||
      {};
    feed.resource_id = resource.id;
    return feed;
  }, state.feeds || []);

  state.resources = R.map(resource => {
    if (resource.ads_product_feed_id) {
      return resource;
    }
    const feed =
      R.find(R.propEq('resource_id', resource.id), state.feeds || []) || {};
    resource.ads_product_feed_id = feed.id;
    return resource;
  }, state.resources || []);

  return state;
}

function Handler(state = INIT_STATE, action) {
  state = Object.assign({}, state);

  ++state.version;
  switch (action.type) {
    case PRODUCT_FEED_CAMPAIGNS_LOADED.response:
      state.campaigns = R.reverse(
        R.sortBy(R.prop('created'), action.data || [])
      );
      state.campaigns = R.filter(campaign => {
        return !campaign.archived;
      })(state.campaigns);
      break;
    case PRODUCT_FEED_CAMPAIGN_CREATED.response:
      state.campaigns.push(action.data);
      state.campaigns = R.reverse(R.sortBy(R.prop('created'), state.campaigns));
      break;
    // case PRODUCT_FEED_CAMPAIGN_SAVED.response:
    //   state.campaigns = R.map(campaign => {
    //     return campaign.id === action.data.id ? action.data : campaign;
    //   })(state.campaigns);
    //   break;
    case PRODUCT_FEED_CAMPAIGN_UPDATED.response:
      const index = R.findIndex(
        R.propEq('id', action.data.id),
        state.campaigns
      );
      const updatedCampaigns = [
        ...state.campaigns.slice(0, index),
        action.data,
        ...state.campaigns.slice(index + 1)
      ];

      state.campaigns = updatedCampaigns;
      break;

    case PRODUCT_FEED_CAMPAIGN_ARCHIVED.response:
      state.campaigns = R.filter(campaign => {
        return campaign.id !== action.data.campaign_id;
      })(state.campaigns);
      state.transformed = R.filter(transformed => {
        return transformed.ads_campaign_id !== action.data.campaign_id;
      })(state.transformed);
      break;

    case PRODUCT_FEED_FEEDS_LOADED.response:
      state.feeds = R.reverse(R.sortBy(R.prop('date'), action.data || []));
      state.feeds = R.filter(feed => {
        return !feed.archived;
      })(state.feeds);
      state = reassociateFeedsWithResources(state);
      break;
    case PRODUCT_FEED_FEED_CREATED.response:
      state.feeds.push(action.data);
      state.feeds = R.reverse(R.sortBy(R.prop('date'), state.feeds));
      state = reassociateFeedsWithResources(state);
      break;
    case PRODUCT_FEED_FEED_SAVED.response:
      state.feeds = R.map(feed => {
        return feed.id === action.data.id ? action.data : feed;
      })(state.feeds);
      break;

    case PRODUCT_FEED_FEED_ARCHIVED.response:
      state.feeds = R.filter(feed => {
        return feed.id !== action.data.feed_id;
      })(state.feeds);
      state.campaigns = R.filter(campaign => {
        return campaign.feed_id !== action.data.feed_id;
      })(state.campaigns);
      state.resources = R.filter(resource => {
        return resource.ads_product_feed_id !== action.data.feed_id;
      })(state.resources);
      state.transformed = R.filter(transformed => {
        return transformed.ads_product_feed_id !== action.data.feed_id;
      })(state.transformed);
      break;

    case PRODUCT_FEED_RESOURCES_LOADED.response:
      state.resources = R.reverse(R.sortBy(R.prop('date'), action.data || []));
      state.resources = R.filter(resource => {
        return !resource.archived;
      })(state.resources);
      state = reassociateFeedsWithResources(state);
      break;

    case PRODUCT_FEED_RESOURCE_CREATED.response:
      if (typeof action.data.headers === 'string') {
        try {
          action.data.headers = JSON.parse(action.data.headers);
        } catch (e) {
          // pass
        }
      }
      state.resources.push({
        app_id: action.data.app_id,
        id: action.data.resource_id,
        headers: action.data.headers,
        ads_product_feed_id: action.data.ads_product_feed_id
      });
      state.resources = R.reverse(R.sortBy(R.prop('date'), state.resources));
      state = reassociateFeedsWithResources(state);
      break;

    case PRODUCT_FEED_TRANSFORMED_LOADED.response:
      state.transformed = R.clone(action.data) || [];
      state.transformed = R.filter(transformed => {
        return !transformed.archived;
      })(state.transformed);
      state = reassociateFeedsWithResources(state);
      break;

    case PRODUCT_FEED_TRANSFORMED_CREATED.response:
      state.transformed.push(action.data);
      state = reassociateFeedsWithResources(state);
      break;

    case PRODUCT_FEED_JOBS_LOADED.response:
      if (action.data) {
        state.jobs = R.reverse(R.sortBy(R.prop('date'), action.data || []));
        state.transformed = R.map(transformed => {
          var job = R.find(
            R.propEq('new_resource_id', transformed.id),
            state.jobs
          );
          if (job) {
            transformed.status = job.status;
          }
          return transformed;
        }, state.transformed || []);
        state = reassociateFeedsWithResources(state);
      }
      break;

    case PRODUCT_FEED_CONFIG_LOADED.response:
      state.providers = action.data || [];
      break;

    case PRODUCT_FEED_CONFIG_CREATED.response:
      state.providers.push(action.data);
      break;

    default:
      break;
  }

  return state;
}

const ProductFeeds = reducerWrapper(INIT_STATE, Handler, {
  request: [
    PRODUCT_FEED_CAMPAIGN_CREATED,
    PRODUCT_FEED_CAMPAIGNS_LOADED,
    PRODUCT_FEED_CAMPAIGN_ARCHIVED,
    PRODUCT_FEED_CAMPAIGN_UPDATED,

    PRODUCT_FEED_JOBS_LOADED,

    PRODUCT_FEED_FEED_CREATED,
    PRODUCT_FEED_FEEDS_LOADED,
    PRODUCT_FEED_FEED_SAVED,
    PRODUCT_FEED_FEED_ARCHIVED,

    PRODUCT_FEED_RESOURCES_LOADED,
    PRODUCT_FEED_RESOURCE_CREATED,

    PRODUCT_FEED_TRANSFORMED_LOADED,
    PRODUCT_FEED_TRANSFORMED_CREATED,
    PRODUCT_FEED_CONFIG_LOADED,
    PRODUCT_FEED_CONFIG_CREATED
  ],
  error: [
    PRODUCT_FEED_CAMPAIGN_CREATED,
    PRODUCT_FEED_CAMPAIGNS_LOADED,
    PRODUCT_FEED_CAMPAIGN_ARCHIVED,
    PRODUCT_FEED_CAMPAIGN_UPDATED,

    PRODUCT_FEED_JOBS_LOADED,

    PRODUCT_FEED_FEED_CREATED,
    PRODUCT_FEED_FEEDS_LOADED,
    PRODUCT_FEED_FEED_SAVED,
    PRODUCT_FEED_FEED_ARCHIVED,

    PRODUCT_FEED_RESOURCES_LOADED,
    PRODUCT_FEED_RESOURCE_CREATED,

    PRODUCT_FEED_TRANSFORMED_LOADED,
    PRODUCT_FEED_TRANSFORMED_CREATED,
    PRODUCT_FEED_CONFIG_LOADED,
    PRODUCT_FEED_CONFIG_CREATED
  ],
  resetOn: ['APP_CHANGE']
});

export default ProductFeeds;
